import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { LoadingSpinner } from '../common/LoadingSpinner';
import LoginForm from '../auth/LoginForm';
import SignupForm from '../auth/SignupForm';
import OAuthCallbackPage from '../../pages/OAuthCallbackPage';
import MainLayout from '../layout/MainLayout';
import HomePage from '../../pages/HomePage';
import LearnPage from '../../pages/LearnPage';
import ExercisePage from '../../pages/ExercisePage';
import ProfilePage from '../../pages/ProfilePage';
import LandingPage from '../../pages/LandingPage';
import PrivacyPolicyPage from '../../pages/PrivacyPolicyPage';
import TermsPage from '../../pages/TermsPage';
import ExtensionPage from '../../pages/ExtensionPage';
import FeedbackPage from '../../pages/FeedbackPage';
import ReviewPage from '../../pages/ReviewPage';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

/**
 * Main application router with protected routes
 */
const AppRouter = () => {
  const { isAuthenticated, isLoading } = useAuth();

  // Show loading spinner while checking authentication
  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <LoadingSpinner size="large" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/login" element={<div className="min-h-screen bg-gray-50 flex items-center justify-center"><LoginForm /></div>} />
          <Route path="/signup" element={<div className="min-h-screen bg-gray-50 flex items-center justify-center"><SignupForm /></div>} />
          <Route path="/callback" element={<OAuthCallbackPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </>
    );
  }

  // Authenticated routes with layout
  return (
    <>
      <ScrollToTop />
      <Routes>
        {/* Always-accessible pages */}
        <Route path="/landing" element={<LandingPage />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route element={<MainLayout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/learn" element={<LearnPage />} />
          <Route path="/exercise" element={<ExercisePage />} />
          <Route path="/extension" element={<ExtensionPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/review" element={<ReviewPage />} />
          <Route path="/feedback" element={<FeedbackPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </>
  );
};

export default AppRouter;